(function($, angular, window) {
    'use strict';
    window.THF.Angular.Filters.filter("escapeQuote", ['$sce', function ($sce) {
        return function (value) {
            if (typeof value === 'string') {
                return value.replace(/\'/gi, '\\\'');
            }
            return value;
        }
    }]);

})(jQuery, angular, window);
